export default "__VITE_ASSET__C7ryEOlk__"